document.addEventListener("turbolinks:load", function () {
  //default select customer type in plan
  $(document).ready(function(){
    $('#select_customer_type').val('');
    $('#question_new_customer').trigger('click');
  })
})